import axios from 'axios'
import qs from 'qs'
import { Dialog } from 'vant'
// create an axios instance
axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
var __retryCount = 0

const service = axios.create({
  timeout: 8000,
  // baseURL: process.env.NODE_ENV === 'production' ? 'https://api.crm.yes-go.cn/' : 'http://api-dev.yes-go.cn/',
  baseURL: 'https://api.crm.yes-go.cn/',
  withCredentials: false
})

// 响应拦截器 设置头部
service.interceptors.request.use(
  config => {
    var timestamp = Date.parse(new Date()).toString() / 1000
    var crmToken
    // 判断缓存中是否有token, 没有退出登录
    config.retry = 5
    config.retryDelay = 1000

    config.headers = {
      'crmtoken': crmToken,
      'appkey': 'fp5bQbRKmX',
      'serial': timestamp,
      'sign': 'vToh4Rc2qw'
    }

    // 如果是put请求,加入请求头
    if (config.method === 'put') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      config.transformRequest = [function(data) {
        return qs.stringify(data)
      }]
    }

    // 拦截post请求
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
      config.transformRequest = [function(data) {
        return qs.stringify(data)
      }]
    }
    return config
  },
  error => {
    // do something with request error
    console.log('error', error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  return response
}, err => {
  var config = err.config
  // 检查是否已经把重试的总数加到最大值
  if (__retryCount >= config.retry) {
    // Reject with the error
    Dialog.alert({
      title: '温馨提示',
      message: '网络错误，请重试或者刷新页面！'
    }).then(() => {
      console.log('挂了五次')
    })
    return Promise.reject(err)
  }
  // 增加重试次数
  __retryCount += 1

  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve()
    }, config.retryDelay || 1)
  })
  // 返回promise，其中调用axios重试请求
  return backoff.then(function() {
    return service(config)
  })
})

export default service
